<ul class="nav nav-tabs custom-nav-tabs " [id]="tabIdPrefix + '_ul_navigation'">
    <li class="nav-item custom-tab" *ngFor="let tab of tabs">
        <a class="nav-link" [class.active]="activeTab === tab.key"
            [id]="tabIdPrefix + '_a_tab_' + tab.key" (click)="selectTab(tab.key)">
            {{tab.label}}
        </a>
    </li>
</ul>

<div class="tab-content border rounded"  [id]="tabIdPrefix + '_div_tabcontent'">
    <div class="tab-content-body">
        <ng-content></ng-content>
    </div>
</div>